import { ImgSrc } from "@/utils";
import {
  Avatar,
  Box,
  Chip,
  colors,
  Stack,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import RelativeTimePlugin from "dayjs/plugin/relativeTime";
import { FC, useEffect, useState } from "react";
import { FeedbackItemProps } from "./feedback-item.types";

dayjs.extend(RelativeTimePlugin);

const FeedbackItem: FC<FeedbackItemProps> = ({
  tag,
  title,
  time,
  body,
  subTitle,
  disabled,
  active,
  imageSrc = "",
  messagesCount,
  onClick,
}) => {
  const [relativeTime, setRelativeTime] = useState<string>(
    dayjs().diff(dayjs(time), "d") >= 1
      ? dayjs(time).format("DD.MM.YYYY")
      : dayjs(time).fromNow()
  );

  useEffect(() => {
    const interval = setInterval(() => {
      const isMoreThanOneDay = dayjs().diff(dayjs(time), "day") >= 1;

      const relativeTimeValue = isMoreThanOneDay
        ? dayjs(time).format("DD.MM.YYYY")
        : dayjs(time).fromNow();
      setRelativeTime(relativeTimeValue);
    }, 1000);

    return () => clearInterval(interval);
  }, [time]);

  return (
    <Box
      sx={{
        display: "flex",
        columnGap: 1,
        borderRadius: 2,
        padding: 1,
        "&:hover": {
          backgroundColor: "#43434353",
          cursor: disabled ? "not-allowed" : "pointer",
        },
        backgroundColor: active ? "#43434353" : "transparent",
        opacity: disabled ? 0.3 : 1,
        cursor: "pointer",
      }}
      onClick={() => !disabled && onClick()}
    >
      {disabled ? (
        <Avatar
          style={{ width: 48, height: 48 }}
          src={ImgSrc(imageSrc, 128, true)}
          alt="user-photo"
        >
          D
        </Avatar>
      ) : (
        <Avatar
          style={{ width: 48, height: 48 }}
          src={ImgSrc(imageSrc, 128, true)}
          alt="user-photo"
        >
          D
        </Avatar>
      )}

      <Stack width="100%" minWidth={0}>
        <Stack direction="row" justifyContent="space-between" spacing={1}>
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography noWrap variant="h6">
              {title}
            </Typography>
            {tag && (
              <Chip
                label={tag.label}
                color={tag.color}
                variant="filled"
                size="small"
              />
            )}
          </Stack>
          <Typography noWrap variant="caption" color="textDisabled">
            {relativeTime}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent={"space-between"} spacing={1.5}>
          <Stack maxWidth="100%">
            {subTitle && (
              <Typography
                sx={{
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  marginBottom: 0.5,
                }}
              >
                {subTitle}
              </Typography>
            )}
            <Typography
              color="textDisabled"
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {body}
            </Typography>
          </Stack>

          {!!messagesCount && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: 20,
                height: 20,
                minWidth: 20,
                borderRadius: "100%",
                backgroundColor: colors.purple[900],
              }}
            >
              <Typography variant="caption">
                {messagesCount < 10 ? messagesCount : "9+"}
              </Typography>
            </Box>
          )}
        </Stack>
      </Stack>
    </Box>
  );
};

export { FeedbackItem };
